import React from 'react';

const AgencyManagerPerformanceIcon: React.FC = props => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="none" viewBox="0 0 32 32">
      <g clipPath="url(#clip0_5316_86401)">
        <path
          fill="#626BFE"
          d="M28 0H4a4 4 0 00-4 4v24a4 4 0 004 4h24a4 4 0 004-4V4a4 4 0 00-4-4z"
        ></path>
        <path
          fill="#fff"
          d="M12.04 14.31c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5-3.5 1.57-3.5 3.5 1.57 3.5 3.5 3.5zM10.89 15.55l.74 1.95-.84 5.29H4.57c.05-3.67 2.78-6.7 6.32-7.24zM17.31 17.63l-2.98 5.16H13.3l-.8-5.29.69-1.95c1.6.24 3.03 1 4.12 2.08z"
        ></path>
        <path
          fill="#fff"
          d="M12.03 15.99c1.71 0 3.33.61 4.6 1.74l-2.61 4.52H5.14c.34-3.5 3.32-6.25 6.89-6.25m0-.55c-4.08 0-7.4 3.27-7.46 7.34h9.76l2.98-5.16a7.486 7.486 0 00-5.28-2.18z"
        ></path>
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M16.47 23.21l3.22-5.58 3.11 1.79 3.23-5.59.06-.09"
        ></path>
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.2"
          d="M23.73 14.37l2.36-.63.63 2.36"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_5316_86401">
          <path fill="#fff" d="M0 0H32V32H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default AgencyManagerPerformanceIcon;
